import { render, staticRenderFns } from "./PromoImages.vue?vue&type=template&id=407650ba&scoped=true"
import script from "./PromoImages.vue?vue&type=script&lang=js"
export * from "./PromoImages.vue?vue&type=script&lang=js"
import style0 from "./PromoImages.vue?vue&type=style&index=0&id=407650ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407650ba",
  null
  
)

export default component.exports